var module = angular.module('octopusApp.infrastructure');

module.controller('AlertDialogController', function ($scope, options, $uibModalInstance) {
    $scope.options = options;

    $scope.close = function() {
        $uibModalInstance.close();
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/controllers/alert_dialog_controller.js
// module id = 2582864119636982
// module chunks = 1